export const refreshModeOptions = ["Workbook", "Sheet"];
export type RefreshMode = (typeof refreshModeOptions)[number];
